<app-navbar></app-navbar>    

<div id="main-content" class="animated fadeIn">
  <div class="container-fluid">

    <!-- contenido-->
    <div class="block-header">
        <div class="row clearfix">
            <div class="col-md-6 col-sm-12">
                <h1 class="color">Mi Trabajo</h1>
                <div class="header">
                    <p style="cursor: pointer;" class="color" (click)="backClicked()"><i class="fa fa-angle-left "  style="font-size: 19px;" aria-hidden="true"></i> Gestor de Tareas / <span class="" style="color: #a5a8ad;">Mi Trabajo</span></p>
                </div>
            </div>            
        </div>
    </div>
    <a class="btn btn-primary btn-round" *ngIf="realizadas" (click)="verTareas()" style="float: left;" style="color:white; cursor: pointer; margin-bottom:10px;">Todas las Tareas</a>
    <a class="btn btn-primary btn-round" *ngIf="!realizadas" (click)="verTareasRealizadas()" style="float: left;" style="color:white; cursor: pointer; margin-bottom:10px;">Tareas Realizadas</a>
              
    <div><small style="margin-left: 20px;" *ngIf="datos_tareas?.tareas?.length == 0">No se tienen tareas registradas</small></div>

    <div class="row" *ngIf="datos_tareas?.tareas?.length != 0">
 
        
    <div class="col-sm-12 style-2" [ngClass]="{ 'col-md-12 col-lg-12':!ver_info, 'col-md-7 col-lg-7':ver_info }" style="overflow-y:scroll; height:600px; scrollbar-width: none;">


    <div class="card d-none d-lg-block d-md-block"  style="margin-bottom: 5px;">
      <div class="body" style="border-radius: 10px; text-align: center;">
          <div class="container">
            
        
            <div class="row">
              <div class=" col-sm-12 col-md-2">
                 Tarea
               </div>
               <div class=" col-sm-12 col-md-2">
                 Proyecto
               </div>
               <div class="col-md-2 col-sm-12" >  
                 Responsable

               </div>
               <div class="col-md-2 col-sm-12">
                 Fecha
               </div>
               
               <div class="col-sm-12 col-md-2">
                     Estatus
               </div>
               <div class="col-md-2 col-sm-12">
                 Acciones
             </div>
           </div>


        </div>
      </div>
    </div>

    <div  *ngFor="let tarea of datos_tareas?.tareas; let in = index" >

      <div class="card" style="margin-bottom: 5px;">
        <div class="body" style="border-radius: 10px;  border-left: 10px solid {{tarea.color}};" >
            <div class="container">
                <div class="row">
                  <div class=" col-sm-12 col-md-2">
                    {{tarea.nombre}}
                  </div>
                  <div class=" col-sm-12 col-md-2">
                    {{tarea.nombre}}
                  </div>
                  <div class="col-md-2 col-sm-12" >  
                    <div *ngFor="let user of datos_tareas?.user" class="col">                                                
                      <div class="" style="float: left; width: 35px; margin-right:3px;"  *ngIf="tarea.id_tarea == user.id_tareas">
                          <button type="button" class="btn btn-outline-secondary " placement="top" *ngIf="tarea.id_tarea == user.id_tareas"
                          ngbPopover='{{user.name}} {{user.last_name}}' ngbTooltip="{{user.name}} {{user.last_name}}" style="border: none !important;" >                                                
                          <img alt="image" src="{{url+''+user.img}}" class="avtar-pic w35 " width="30" >
                          </button>
                        </div>                                                                                             
                  </div>    
   
                  </div>
                  <div class="col-md-2 col-sm-12">
                    <div *ngIf="tarea.tipo_fecha == 0">
                      <p [innerHTML]="tarea.fecha"></p>
                    </div>
                    <div *ngIf="tarea.tipo_fecha == 1">
                        <p [innerHTML]="tarea.fecha">,</p>
                        <p [innerHTML]="tarea.fecha2"></p>
                    </div>
                  </div>
                  
                  <div class="col-sm-12 col-md-2">
                    <div class="row" style="top: -20px;">
                      <div class="col-12 col-md-12 col-sm-12"><label for="">Importancia</label></div>
                        <div class="col-12 col-md-12 col-sm-12">
                            <div class="badge {{tarea.importancia_color}} click" popoverTitle="Editar Importancia"
                                [autoClose]="'outside'" [ngbPopover]="popOver" placement="top" container="body" style="">
                                  {{tarea.importancia}}
                              </div>                         
                        </div>
                     </div>
                     <ng-template #popOver>
                       <form #importanciaForm="ngForm" (ngSubmit)="onSubmitImportancia(importanciaForm)">
                      Selecciona una opción:
                      <input type="hidden" ngModel="{{tarea.id_tarea}}"  name="id_tarea">
                      <input type="hidden" ngModel="{{in}}"  name="num">
                        <input type="radio" id="customRadio1" name="importancia" [ngModel]="tarea.num_importancia"  [value]="3" [checked]="tarea.num_importancia === 3">
                        <label class="input_radio" style="margin-bottom: -15px; "  for="customRadio1">Alto</label>
                      
                      
                        <input type="radio" id="customRadio2" name="importancia" [ngModel]="tarea.num_importancia"  [value]="2" [checked]="tarea.num_importancia === 2">
                        <label class="input_radio" style="margin-bottom: -15px; " for="customRadio2">Medio</label>
                      
                      
                        <input type="radio" id="customRadio3" name="importancia" [ngModel]="tarea.num_importancia"  [value]="1" [checked]="tarea.num_importancia === 1">
                        <label class="input_radio" style="margin-bottom: -15px;" for="customRadio3">Bajo</label>
                      
                      <button type="submit" class="btn btn-success" style="margin-top: 22px; margin-bottom: 6px; height: 25px; padding: 0px 20px 0px 20px; float: right;">Guardar</button>
                    </form>
                    </ng-template>


                    <div class="row">
                        <div class="col-12 col-md-12 col-sm-12"><label for="">Estatus</label></div>
                        <div class="col-12 col-md-12 col-sm-12">
                            <div class="badge badge-primary click" popoverTitle="Editar Estatus"
                            [autoClose]="'outside'" [ngbPopover]="popOverEstatus" placement="top" container="body" style="">
                            {{tarea.estatus}}         
                            </div>
                            
                        </div>

                        <ng-template #popOverEstatus>
                          <form #estatusForm="ngForm" (ngSubmit)="onSubmitEstatus(estatusForm)">
                         Selecciona el estatus: {{tarea.id_estatus}} 
                         <input type="hidden" ngModel="{{tarea.id_tarea}}"  name="id_tarea">
                         <input type="hidden" ngModel="{{in}}"  name="num">
                          <div *ngFor="let estate of datos_tareas?.estatus"> 
                            
                          <input type="radio" id="customRadio{{estate.id_estatus}}" name="estatus" [ngModel]="tarea.id_estatus"  [value]="estate.id_estatus" [checked]="tarea.id_estatus === estate.id_estatus">
                           <label class="input_radio" style="margin-bottom: -15px; "  for="customRadio{{estate.id_estatus}}">{{estate.estatus}}</label>
                          </div>
                         <button type="submit" class="btn btn-success" style="margin-top: 22px; margin-bottom: 6px; height: 25px; padding: 0px 20px 0px 20px; float: right;">Guardar</button>
                       </form>
                       </ng-template>
                        
                    </div> 
                  </div>
                  <div class="col-md-2 col-sm-12">
                    <button class="btn btn-outline-primary"  style="margin: 4px;" (click)="abrirInfo(tarea)"><i class="fa fa-comments"></i></button>

                </div>


                
                  
                  
                </div>
              </div>
        </div>
      </div> <!-- end card -->

      </div>
    
    </div>

    <div class="col-sm-12 col-md-5 col-lg-5 style-2" *ngIf="ver_info"  style="overflow-y:scroll; height:600px; scrollbar-width: none;">    
      <app-info [info]="ver_tarea" (cerrarInfo)="cerrarInfo()"></app-info>
    </div>
        

        <!-- end contenido-->
      </div>
    </div>
</div>